(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinch-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function boot(el) {
    if (!el) return;
    if (reduce) { el.classList.add('boot'); return; }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('boot'); });
    });
  }
  function init() {
    var heroes = document.querySelectorAll('.cinch-hero');
    for (var i = 0; i < heroes.length; i++) { boot(heroes[i]); }
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', function (e) {
    var el = (e.target && e.target.querySelector) ? e.target.querySelector('.cinch-hero') : null;
    if (el) { el.classList.add('boot'); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinch-pdp-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(el){
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var dur = parseInt(el.getAttribute('data-dur'), 10) || 1600;
    var dec = (el.getAttribute('data-count') || '').indexOf('.') > -1 ? 1 : 0;
    if (reduce){ el.textContent = target.toFixed(dec); return; }
    var start = null;
    function step(ts){
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(dec);
      if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec);
    }
    requestAnimationFrame(step);
  }
  function Scope(canvas){
    var ctx = canvas.getContext('2d');
    var dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
    var t = 0;
    function size(){ var r = canvas.getBoundingClientRect(); canvas.width = Math.max(1, r.width*dpr); canvas.height = Math.max(1, r.height*dpr); }
    function trace(animated){
      var w = canvas.width, h = canvas.height; ctx.clearRect(0,0,w,h);
      ctx.lineWidth = 2*dpr; ctx.strokeStyle = '#FF3B2E';
      if (animated){ ctx.shadowBlur = 7*dpr; ctx.shadowColor = 'rgba(255,59,46,.5)'; }
      ctx.beginPath();
      for (var x=0; x<=w; x+=2*dpr){
        var u = x/w;
        var y = animated ? (h/2 + Math.sin(u*9 + t)*h*0.20 + Math.sin(u*23 - t*1.7)*h*0.07) : (h/2 + Math.sin(u*9)*h*0.18);
        if (x===0) ctx.moveTo(x,y); else ctx.lineTo(x,y);
      }
      ctx.stroke(); ctx.shadowBlur = 0;
    }
    function frame(){ trace(true); t += 0.06; requestAnimationFrame(frame); }
    size();
    if (reduce){ trace(false); } else { frame(); }
    if (window.ResizeObserver){ new ResizeObserver(function(){ size(); if (reduce) trace(false); }).observe(canvas); }
  }
  function initPdp(root){
    if (root.dataset.pdpInit) return; root.dataset.pdpInit = '1';
    /* gallery */
    var galMain = root.querySelector('[data-role="galMain"]');
    if (galMain){
      var galUnit = galMain.closest('.unit');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('.thumb'));
      function galIndex(){ for (var i=0;i<thumbs.length;i++){ if (thumbs[i].classList.contains('active')) return i; } return 0; }
      function galSelect(t){
        if (!t) return;
        var src = t.getAttribute('data-img'); if (!src) return;
        thumbs.forEach(function(x){ x.classList.remove('active'); x.setAttribute('aria-current','false'); });
        t.classList.add('active'); t.setAttribute('aria-current','true');
        var pre = new Image();
        pre.onload = function(){ if (galUnit) galUnit.classList.remove('err'); galMain.style.opacity='0'; setTimeout(function(){ galMain.src = src; galMain.style.opacity='1'; }, 170); };
        pre.onerror = function(){ if (galUnit) galUnit.classList.add('err'); };
        pre.src = src;
      }
      thumbs.forEach(function(t){ t.addEventListener('click', function(){ galSelect(t); }); });
      galMain.addEventListener('error', function(){ if (galUnit) galUnit.classList.add('err'); });
      if (galUnit && thumbs.length > 1){
        galUnit.addEventListener('click', function(){ galSelect(thumbs[(galIndex()+1) % thumbs.length]); });
        galUnit.addEventListener('keydown', function(e){
          if (e.key==='ArrowRight'){ e.preventDefault(); galSelect(thumbs[(galIndex()+1)%thumbs.length]); }
          else if (e.key==='ArrowLeft'){ e.preventDefault(); galSelect(thumbs[(galIndex()-1+thumbs.length)%thumbs.length]); }
          else if (e.key===' '||e.key==='Enter'){ e.preventDefault(); galSelect(thumbs[(galIndex()+1)%thumbs.length]); }
        });
      }
    }
    /* qty stepper (updates the hidden quantity field too) */
    var qv = root.querySelector('[data-role="qty"]');
    var qInput = root.querySelector('[data-role="qty-input"]');
    if (qv){
      root.querySelectorAll('.qbtn').forEach(function(b){
        b.addEventListener('click', function(){
          var step = parseInt(b.getAttribute('data-step'), 10) || 0;
          var v = Math.max(1, Math.min(99, (parseInt(qv.textContent, 10) || 1) + step));
          qv.textContent = v;
          if (qInput) qInput.value = v;
        });
      });
    }
    /* variant select -> price + availability */
    var sel = root.querySelector('[data-role="variants"]');
    if (sel){
      var priceEl = root.querySelector('[data-role="price"]');
      var compareEl = root.querySelector('[data-role="compare"]');
      var saveEl = root.querySelector('[data-role="save"]');
      var addBtn = root.querySelector('[data-role="add"]');
      var addLabel = root.querySelector('[data-role="add-label"]');
      var addDefault = addLabel ? addLabel.textContent : 'Add to cart';
      sel.addEventListener('change', function(){
        var opt = sel.options[sel.selectedIndex]; if (!opt) return;
        if (priceEl && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
        var hasC = opt.getAttribute('data-has-compare') === '1';
        if (compareEl){ if (hasC){ compareEl.textContent = opt.getAttribute('data-compare'); compareEl.hidden = false; } else { compareEl.hidden = true; } }
        if (saveEl){ if (hasC){ saveEl.textContent = 'Save ' + opt.getAttribute('data-save'); saveEl.hidden = false; } else { saveEl.hidden = true; } }
        var avail = opt.getAttribute('data-available') === 'true';
        if (addBtn) addBtn.disabled = !avail;
        if (addLabel) addLabel.textContent = avail ? addDefault : 'Sold out';
      });
    }
    /* oscilloscope */
    var sc = root.querySelector('[data-role="scope"]');
    if (sc) Scope(sc);
    /* count-ups */
    var counts = Array.prototype.slice.call(root.querySelectorAll('[data-count]'));
    if (counts.length){
      if ('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if (en.isIntersecting){ countUp(en.target); io.unobserve(en.target); } }); }, {threshold:.4});
        counts.forEach(function(c){ io.observe(c); });
      } else { counts.forEach(countUp); }
    }
  }
  function reveal(root){ if (reduce){ root.classList.add('is-in'); return; } requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-in'); }); }); }
  function boot(){ var n = document.querySelectorAll('.cinch-pdp'), i; for (i=0;i<n.length;i++){ initPdp(n[i]); reveal(n[i]); } }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(e){ var r = e.target.querySelector('.cinch-pdp'); if (r){ initPdp(r); reveal(r); } });
})();

  } catch(e) { console.error(e); }
})();
})();
